import { log } from '@/utils/loger';

const ALERT_TYPE = {
  INVALID_PROMO_CODE_WARNING: 'invalidPromoCodeWarning'
};

const resolvers = {};

export const UserAlertService = {
  ALERT_TYPE,
  registerAlert(alertType, resolver) {
    if (resolvers[alertType]) {
      throw Error(
        `Cant register more than one resolver for the alert. Alert ${alertType} is already registered.`
      );
    }

    resolvers[alertType] = resolver;
  },
  unregisterAlert(alertType) {
    resolvers[alertType] = null;
  },
  async askUserForAproval(alertType, payload) {
    const resolver = resolvers[alertType];

    if (!resolver) {
      log.error(`No resolver registered for the alert ${alertType}`);

      return false;
    }

    // resolver should return Promise<boolean>
    return resolver(payload);
  }
};
